import { UrlParams } from 'enums/UrlParams';
import { RoutePath } from 'enums/Routes';
import { HTTPStatusCodes } from 'api/Api';

import { getApiRevision } from './getApiUrls';

/**
 * Get URI encoded pathname + any get variables of current URL so we can store it for redirection.
 */
export function getUrlPathForRedirection(): string {
  return encodeURIComponent(window.location.pathname + window.location.search);
}

/**
 * Get redirect path when we need to relogin
 */
export function getRedirectPathForLogin(statusCode?: HTTPStatusCodes): string {
  const suffix = getApiRevision() ? `&${UrlParams.ApiRevision}=${getApiRevision()}` : '';
  if (statusCode === HTTPStatusCodes.CONFLICT) return `${RoutePath.SmsLogin}${suffix ? `?${suffix}` : ''}`;

  return `${RoutePath.SmsLogin}?${UrlParams.ComingFrom}=${getUrlPathForRedirection()}${suffix}`;
}
